// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* variables */
:root {
	/* fonts */
	--main-font-size: 15px;
	--logo-font-size: 20px;
	--middle-font-size: 18px;
	--large-font-size: 34px;
	--mini-font-size: 13px;
  
	/* icons */
	--icon-size: 18px;
  
	/* colors */
	--main-color: #464A52;
	--main-color-light: #6E7480;
	--placeholder-color: rgba(110,116,128,0.6);
	--icon-color: #6E7480;
	--header-logo-color: #ffffff;
	--select-color: #F4F5F9;
	--overlay-text-color: #94A1B3;
	--pager-color: #fff;
  
	/* backgrounds */
	--header-bg: #054c8f;
	--header-bg-light: #2d73b3;
	--main-bg: #fff;
	--dark-main-bg: #E8EBF1;
	--tab-bg: #BDC4D4;
	--tab-bg-active: #0288D1;
	--selected-bg: #0288D1;
	--selected-bg2: #01aed1;
	--select-hover-bg: #f5f5f5;
  
	/* buttons */
	--btn: #0288D1;
	--btn-hover: #0277BD;
	--btn-contour: #E7E9F2;
	--popup-close-icon: #BDC4D4;
  
	/* borders */
	--lines-color: #BDC4D4;
	--lines-color-light: #E8EBF1;
	--lines-color-invalid: #fea5a8;
  }`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA,cAAc;AACd;CACC,UAAU;CACV,sBAAsB;CACtB,sBAAsB;CACtB,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;;CAEtB,UAAU;CACV,iBAAiB;;CAEjB,WAAW;CACX,qBAAqB;CACrB,2BAA2B;CAC3B,0CAA0C;CAC1C,qBAAqB;CACrB,4BAA4B;CAC5B,uBAAuB;CACvB,6BAA6B;CAC7B,mBAAmB;;CAEnB,gBAAgB;CAChB,oBAAoB;CACpB,0BAA0B;CAC1B,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,wBAAwB;CACxB,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;;CAE1B,YAAY;CACZ,cAAc;CACd,oBAAoB;CACpB,sBAAsB;CACtB,2BAA2B;;CAE3B,YAAY;CACZ,sBAAsB;CACtB,4BAA4B;CAC5B,8BAA8B;EAC7B","sourcesContent":["/* variables */\n:root {\n\t/* fonts */\n\t--main-font-size: 15px;\n\t--logo-font-size: 20px;\n\t--middle-font-size: 18px;\n\t--large-font-size: 34px;\n\t--mini-font-size: 13px;\n  \n\t/* icons */\n\t--icon-size: 18px;\n  \n\t/* colors */\n\t--main-color: #464A52;\n\t--main-color-light: #6E7480;\n\t--placeholder-color: rgba(110,116,128,0.6);\n\t--icon-color: #6E7480;\n\t--header-logo-color: #ffffff;\n\t--select-color: #F4F5F9;\n\t--overlay-text-color: #94A1B3;\n\t--pager-color: #fff;\n  \n\t/* backgrounds */\n\t--header-bg: #054c8f;\n\t--header-bg-light: #2d73b3;\n\t--main-bg: #fff;\n\t--dark-main-bg: #E8EBF1;\n\t--tab-bg: #BDC4D4;\n\t--tab-bg-active: #0288D1;\n\t--selected-bg: #0288D1;\n\t--selected-bg2: #01aed1;\n\t--select-hover-bg: #f5f5f5;\n  \n\t/* buttons */\n\t--btn: #0288D1;\n\t--btn-hover: #0277BD;\n\t--btn-contour: #E7E9F2;\n\t--popup-close-icon: #BDC4D4;\n  \n\t/* borders */\n\t--lines-color: #BDC4D4;\n\t--lines-color-light: #E8EBF1;\n\t--lines-color-invalid: #fea5a8;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
